import { FC } from 'react';
import cn from 'clsx';

import './Embed.css';

type Props = React.DetailedHTMLProps<
  React.IframeHTMLAttributes<HTMLIFrameElement>,
  HTMLIFrameElement
>;

const Embed: FC<Props> = ({ className, style, ...props }) => {
  return (
    <div className={cn('embed-frame', className)} style={style}>
      <iframe title={props.title} frameBorder="0" allowFullScreen {...props} />
    </div>
  );
};

export default Embed;
